import * as history from 'history';
/* {
   basename: process.env.PUBLIC_URL,
} */
export default history.createBrowserHistory();
